import React, { useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchData, viewdata } from '../reduxactions/donorrsactions/DNeedsReduxAction';
import { useNavigate } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';


const DonorNeeds = () => {

    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])

    const data = useSelector((state: RootState) => state.dneed.data);
    const dataview = useSelector((state: RootState) => state.dneed.dataview);

    const navigate = useNavigate();

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const [assignData, setassignData] = useState({
        Id: '',
    });
    // const viewuploaddata = (rowData: any) => {
    //     // setassignData({
    //     //     Id: rowData.Id,

    //     // });



    //     setfield(true);
    //     fetchDataAsyncdialog();
    // };
    const viewuploaddata = (rowData: any) => {
        try {
            const { Id } = rowData.Id;
            console.log("ids", rowData.Id)
            dispatch(viewdata(rowData.Id) as any);
            setfield(true)
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    // const fetchDataAsyncdialog = async () => {
    //     try {
    //         const { Id } = assignData;
    //         console.log("ids", Id)
    //         dispatch(viewdata(Id) as any);
    //     } catch (error) {
    //         console.error('Error deleting data:', error);
    //     }
    // }
    //To open view
    const viewupload = (rowData: any) => {
        console.log('rowdata', rowData)
        const url = `/needsview/${rowData.Id}/${rowData.needid}`;

        console.log('Row ID:', rowData.Id);

        // Use navigate to navigate to the URL
        navigate(url);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donor-needs.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (

        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Needs</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Needs</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* <section className="content"> */}
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>
                                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                                        <Column field="needtype" sortable header="Need Type"></Column>
                                        <Column header="Description" body={(rowData) => (
                                            <span>{rowData.needtittle}<br />{rowData.description}</span>
                                        )}></Column>
                                        <Column field="budget_amount" sortable header="Budget Amount"></Column>
                                        <Column field="required_amount" sortable header="Required Amount"></Column>
                                        <Column field="status" sortable header="Status"></Column>

                                        <Column header="Option" body={(rowData, { rowIndex }) => (
                                            <div className="grid">
                                                {/* <Button icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} rounded outlined tooltip="View" style={{ width: '2rem', height: '2rem', color: 'blue' }} tooltipOptions={{ position: 'left' }}
                                                    onClick={() => viewupload(rowData)} />
                                                <Button
                                                    icon="pi pi-user"
                                                    rounded
                                                    outlined
                                                    tooltip="Donors"
                                                    data-testid={`show-btn-${rowIndex}`}
                                                    tooltipOptions={{ position: 'left' }}
                                                    style={{ width: '2rem', height: '2rem', color: 'blueviolet' }}
                                                    onClick={() => viewuploaddata(rowData)}
                                                /> */}
                                                <GFNButton icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} className='mr-3' rounded outlined tooltip="View" buttonType='primary' onClick={() => viewupload(rowData)}  tooltipOptions={{ position: 'left' }}/>
                                                <GFNButton
                                                    icon="pi pi-user"
                                                    rounded
                                                    outlined
                                                    tooltip="Donors"
                                                    data-testid={`show-btn-${rowIndex}`}
                                                    buttonType='secondary'
                                                    tooltipOptions={{ position: 'left' }}
                                                    onClick={() => viewuploaddata(rowData)}
                                                />

                                            </div>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Panel>
                        {/* </section> */}
                        {/* {/ Assign DIALOG /} */}
                        <Dialog header="View Donors" style={{ width: '30vw' }} visible={acceptfield} onHide={cancelfield}>
                            <DataTable value={dataview} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '30rem' }} globalFilter={globalFilter} >
                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>

                                <Column header="Donor Name" body={(rowData) => (
                                    <span>{rowData.firstname}<br />{rowData.lastname}</span>
                                )}></Column>

                            </DataTable>
                            <Button label="Close" data-testid="close-btn" onClick={cancelfield} className="mr-3 p-button-secondary" />
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DonorNeeds
